import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import "./app-logo.m.css";
import { useDispatch, useSelector } from "react-redux";
import { RADIOT_HELSINKI, RADIOT_KAJANI, RADIOT_KEMI, RADIOT_KOKKOLA, RADIOT_KRISTIINANKAUPPUNKI, RADIOT_LAHTI, RADIOT_OULU, RADIOT_ROVANIEMI, RADIOT_TORNIO, RADIOT_TURKU, RADIOT_YLEISOHJELMA } from "../../store/actions";

const AppLogo = ({isUserLoginPage = false}) => {
  const dispatch = useDispatch();
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  let homepageSlug = "";
  const currentPath = get(qtState, ["currentPath"], "");
  if (currentPath.startsWith("/lammas")) {
    homepageSlug = "/";
  } else {
    homepageSlug = "/";
  }

  return (
    <Link
      href={homepageSlug}
      aria-label="Etusivulle"
      onClick={() => {
        setNavSelected("etusivu");
        dispatch({
          type: RADIOT_HELSINKI,
          isRadiotHelsinkiClicked: false,
        });
        dispatch({
          type: RADIOT_LAHTI,
          isRadiotLahtiClicked: false,
        });
        dispatch({
          type: RADIOT_ROVANIEMI,
          isRadiotRovaniemiClicked: false,
        });
        dispatch({
          type: RADIOT_OULU,
          isRadiotOuluClicked: false,
        });
        dispatch({
          type: RADIOT_YLEISOHJELMA,
          isRadiotYleisohjelmaClicked: false,
        });
        dispatch({
          type: RADIOT_KAJANI,
          isRadiotKajaniClicked: false,
        });
        dispatch({
          type: RADIOT_TURKU,
          isRadiotTurkuClicked: false,
        });
        dispatch({
          type: RADIOT_KEMI,
          isRadiotKemiClicked: false,
        });
        dispatch({
          type: RADIOT_TORNIO,
          isRadiotTornioClicked: false,
        });
        dispatch({
          type: RADIOT_KOKKOLA,
          isRadiotKokkolaClicked: false,
        });
        dispatch({
          type: RADIOT_KRISTIINANKAUPPUNKI,
          isRadiotKristiinankauppunkiClicked: false,
        });
      }}
    >
      <img
        src="/icons/radio_dei_plus.svg"
        alt="app-logo"
        styleName={isUserLoginPage ? "publisher-logo-header-small" : "publisher-logo-header"}
        className="app-logo" />
    </Link>
  );
};

export { AppLogo };
